import { VStack, Box, Button } from '@cad-arc';
import { EventSearchOptions } from '@mark43/cad-api';
import { useFieldArray, UseFormReturn } from 'react-hook-form';
import { FormSection } from '../search-windows/form-section';
import { EventSearchFormType } from './types';
import { personFormDefaultValues } from '../search-windows/configuration';
import { SearchFormPersonFields } from '../search-windows/search-form-person-fields';

const MAX_PERSON_COUNT = 3;

export function EventSearchFormPersonInformationSection({
    form,
    options,
    isFirstResponder,
}: {
    isFirstResponder?: boolean;
    form: UseFormReturn<EventSearchFormType>;
    options: EventSearchOptions;
}) {
    const { fields, append, remove } = useFieldArray({ control: form.control, name: 'persons' });
    return (
        <FormSection title="Person Information" testId="event-search-person-information-section">
            <VStack align="left" gap="4px">
                {fields.map((field, index) => {
                    return (
                        <SearchFormPersonFields
                            key={field.id}
                            options={options}
                            index={index}
                            isFirstResponder={isFirstResponder}
                            isRemovable={fields.length > 1}
                            onRemove={() => remove(index)}
                        />
                    );
                })}
                <Box w="120px">
                    <Button
                        variant="ghost"
                        leadingVisual="Add"
                        onClick={() => append(personFormDefaultValues)}
                        isDisabled={fields.length >= MAX_PERSON_COUNT}
                    >
                        Add Person
                    </Button>
                </Box>
            </VStack>
        </FormSection>
    );
}
